export const MORE_FILTERS_TEXT = "More Filters";
export const getFiltersAppliedText = (count: number) =>
  `(${count}) Filter${count > 1 ? "s" : ""} applied`;
export const EDIT_TRAVELERS_TITLE = "Travelers";
